import { ConfigProvider } from "antd";
import Layout from "antd/lib/layout";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IS_EBM_TRAINING_ON } from "../../../config/constants";
import { routes } from "../../../config/route-config";
import { getFromLocal } from "../../../helpers/handleLocalStorage";
import { ebmTrainingStatus } from "../../../lib/redux/slices/ebm-training-status";
import { RootState } from "../../../lib/redux/store";
import { COLOR_VALUES } from "../../../lib/types/shared/enums";
import { antdGlobalTheme } from "../../../themes/constants";
import AppHeader from "./AppHeader";
import AppSider from "./AppSider";
import ResumeMoMo from "./ResumeMoMo";

const { Content, Header } = Layout;

export interface Types {
  children: React.ReactNode;
}

/**
 * @since February 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element}
 */

const AppLayout = ({ children }: Types): JSX.Element => {
  const router = useRouter();
  const dispatcher = useDispatch();

  const isAtPrivacyPolicy = router.pathname.includes(
    routes.Policy.url || routes.Agreements.url
  );
  const token = useSelector((state: RootState) => state.auth.payload);

  useEffect(() => {
    const is_ebm_training_on = getFromLocal(IS_EBM_TRAINING_ON);
    dispatcher(ebmTrainingStatus({ payload: is_ebm_training_on === "true" }));
  }, [dispatcher]);

  return token && !isAtPrivacyPolicy ? (
    <ConfigProvider theme={antdGlobalTheme}>
      <Layout>
        <Header className="bg-ox_2_darker_blue px-8">
          <AppHeader />
        </Header>

        <Layout>
          <AppSider />
          <Content style={{ background: COLOR_VALUES.ox_2_input_white }}>
            <ResumeMoMo />
            {children}
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  ) : (
    <>{children}</>
  );
};

export default AppLayout;
